import React, { useEffect, useState } from 'react';
import VideoContainer from './VideoContainer';
import { usePlayerStore, getStore } from '../../../stores/StoreContext';
import { useSecondPaneContext } from '../../Common/SplitView/SplitViewContext';
const Focused = () => {
  const SessionTracks = usePlayerStore((state) => state.tracks);
  const focusedTrackId = usePlayerStore((state) => state.focusedTrackId);
  const { width, height } = useSecondPaneContext();
  const [trackStatus, setTrackStatus] = useState(false);

  const currentTime = usePlayerStore((state) => state.currentTime);
  const PlayerStore = getStore('playerStore');

  // Evaluate the focused track's status at the current playback time.
  // Guard against focusedTrackId referencing a track that hasn't been added to the
  // tracks collection yet (e.g., during the async window between autoSetFocusedTrack
  // selecting a track and TrackMonitor populating it with WebRTC data).
  useEffect(() => {
    const focusedTrack = SessionTracks[focusedTrackId];
    if (focusedTrack) {
      setTrackStatus(PlayerStore.getTrackStatusAtTime(focusedTrack, currentTime));
    }
  }, [currentTime, focusedTrackId, SessionTracks]);

  // Auto-focus a track if none is focused but tracks are available
  useEffect(() => {
    if (!focusedTrackId && Object.keys(SessionTracks).length > 0) {
      PlayerStore.autoSetFocusedTrack(true);
    }
  }, [focusedTrackId, SessionTracks, PlayerStore]);

  return (
    <>
      {focusedTrackId && (
        // Key includes lastUpdated timestamp to force VideoContainer remount on reconnection
        // This ensures the entire video component tree re-renders when tracks reconnect
        <VideoContainer
          key={`focused_${focusedTrackId}_${SessionTracks[focusedTrackId]?.lastUpdated || 0}`}
          isFocusedTrack={true}
          SessionTrack={SessionTracks[focusedTrackId]}
          width={width}
          height={height}
          trackStatus={trackStatus}
        />
      )}
    </>
  );
};

export default Focused;
